export default {
  discount: {},
  discounts: [],
};
